export function formatCurrency(value) {
    if (value) {
        value = parseInt(value);
        const number = Math.abs(value);
        const formattedNumber = Number(number).toLocaleString();
        return value < 0 ? "- £" + formattedNumber : "£" + formattedNumber;
    } else {
        return "£0";
    }
}

export function formatCurrencyRounded(value) {
    if (value) {
        const number = (value / 1).toFixed(0).replace(",", ".");
        return number < 0 ?
            "- £" + +number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") :
            "£" + number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return "£0";
}

export function formatStringCurrencyDecimal(value) {
    if (value) {
        const number = parseFloat(value.replace(/,/g, ""));
        const formattedNumber = Number(number)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        return value < 0 ? "- £" + formattedNumber : "£" + formattedNumber;
    }
    return "£0";
}

export function formatCurrencyDecimal(value) {
    if (value) {
        const formattedNumber = Number(value)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        return value < 0 ? "- £" + formattedNumber : "£" + formattedNumber;
    }
    return "£0";
}